import { getData, postData, } from '@/store/helpers'
import { processFields, } from '@/store/modules/record/modules/challenge/helpers'

export default {
  async getField ({ commit, state, }, id) {
    try {
      const field = await getData({ state, }, { endpoint: `fields/${id}`, })
      return field.data.attributes
    } catch (error) {
      console.error(error)
    }
  },
  async postFile ({ commit, state, rootState, }, formData) {
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${rootState.auth.token}`,
    }
    const response = await postData({
      data: formData,
      headers,
      endpoint: 'attachments/upload',
      apiV: 'api/v1/',
    })
    return response.data.data.id
  },
  async saveSummary (
    { state, rootState, rootGetters, },
    { comment = null, evidenceId, evidenceText, email, }
  ) {
    const { lei, } = rootState.record.record
    const { rawRecord, } = rootState.record
    const owner = rootState.record.record.registration.managingLou
    const { fields, } = state
    const directParentLei = rootState.record.directParent ? rootState.record.directParent.lei : null
    const ultimateParentLei = rootState.record.ultimateParent ? rootState.record.ultimateParent.lei : null
    const fundManagerLei = rootState.record.fundManager ? rootState.record.fundManager.lei : null
    const umbrellaFundLei = rootState.record.umbrellaFund ? rootState.record.umbrellaFund.lei : null
    const masterFundLei = rootState.record.masterFund ? rootState.record.masterFund.lei : null
    const headOfficeLei = rootState.record.headOffice ? rootState.record.headOffice.lei : null

    let formattedFields = await processFields(
      fields,
      directParentLei,
      ultimateParentLei,
      fundManagerLei,
      umbrellaFundLei,
      masterFundLei,
      headOfficeLei
    )

    const data = {
      type: 'challenges',
      attributes: {
        lei,
        owner,
        evidence_id: evidenceId,
        meta: JSON.stringify(rawRecord),
        comment,
        ...formattedFields,
        // email,
        // classification: 'LEI_REFERENCE_DATA_CHALLENGE',
        // evidence_text: evidenceText || null,
      },
    }

    return await postData({
      data: { data, },
      endpoint: 'lei-challenges/legacy',
      apiV: 'api/v1/',
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/modules/challenge/actions.js